export enum KdfType {
  PBKDF2_SHA256 = 0,
  ARGON2ID = 1
}
